<div class="container">
  <div
    [ngStyle]="{ backgroundColor: Color }"
    [ngClass]="{
      circle: Figure?.toString() == 'Circle',
      square: Figure?.toString() == 'Square',
      halfCircle: Figure?.toString() == 'HalfCircle'
    }"
  ></div>
</div>
